export default __webpack_public_path__ + "static/media/37.44f0d1a7.png";